import React, { useEffect, useState } from "react";
import Wordmark from "../Wordmark";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            style={{
                position: "sticky",
                top: 0,
                zIndex: 50,
                backgroundColor: scrolled
                    ? "rgba(244, 239, 229, 0.92)"
                    : "var(--bt-paper)",
                backdropFilter: scrolled ? "saturate(140%) blur(10px)" : "none",
                WebkitBackdropFilter: scrolled ? "saturate(140%) blur(10px)" : "none",
                borderBottom: scrolled ? "1px solid var(--bt-rule)" : "1px solid transparent",
                transition: "background-color 220ms ease, border-color 220ms ease",
            }}
        >
            <div
                className="bt-shell"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingTop: 22,
                    paddingBottom: 22,
                    gap: 24,
                }}
            >
                <a
                    href="#hero"
                    aria-label="Brass Tacks Brief, home"
                    style={{ display: "inline-flex", alignItems: "center" }}
                    data-testid="header-wordmark-link"
                >
                    <Wordmark size="md" />
                </a>

                <nav style={{ display: "flex", alignItems: "center", gap: 28 }}>
                    <a
                        href="#sample-issue"
                        className="f-ui"
                        style={{
                            fontSize: 13,
                            color: "var(--bt-ink-soft)",
                            textDecoration: "none",
                            fontWeight: 400,
                        }}
                        data-testid="header-sample-link"
                    >
                        Read a sample
                    </a>
                    <a
                        href="#recap"
                        className="f-ui"
                        style={{
                            fontSize: 13,
                            color: "var(--bt-ink)",
                            textDecoration: "none",
                            fontWeight: 500,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                        data-testid="header-subscribe-link"
                    >
                        Subscribe <span aria-hidden="true">→</span>
                    </a>
                </nav>
            </div>
        </header>
    );
}
